import { render, staticRenderFns } from "./supplierDetails.pug?vue&type=template&id=1161252f&lang=pug&"
import script from "./supplierDetails.ts?vue&type=script&lang=ts&"
export * from "./supplierDetails.ts?vue&type=script&lang=ts&"
import style0 from "./supplierDetails.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports